import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RappiderLottiePlayerModule } from '@rappider/rappider-components';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzUploadFile, NzUploadModule } from 'ng-zorro-antd/upload';
import { renderedPageAnimationOptions } from '../../models';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

export const GENERATE_WITH_AI_GUIDANCE = 'Describe what you want and optionally drag and drop an image in this container. Rapider AI will create the component based on your description and the uploaded image within this container.';

@Component({
  selector: 'rappider-generate-component-with-ai',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzUploadModule,
    NzModalModule,
    NzButtonModule,
    NzToolTipModule,
    RappiderLottiePlayerModule
  ],
  templateUrl: './generate-component-with-ai.component.html',
  styleUrls: ['./generate-component-with-ai.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenerateComponentWithAiComponent {

  @Input() animationIndex?: number = 0;

  @Output() fileUploaded = new EventEmitter<NzUploadFile>();
  @Output() fileRemoved = new EventEmitter<string>();
  @Output() componentGenerationRequest = new EventEmitter<any>();

  fileList: NzUploadFile[] = [];
  previewImage: string | undefined = '';
  previewVisible = false;

  // eslint-disable-next-line max-len
  textAreaPlaceholder = GENERATE_WITH_AI_GUIDANCE;
  componentDefinitionDescription: string | undefined;

  /* Empty container animations */
  animationOptions = renderedPageAnimationOptions;

  getBase64(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  handlePreview = async (file: NzUploadFile): Promise<void> => {
    if (!file.url && !file.preview) {
      if (file.originFileObj) {
        file.preview = await this.getBase64(file.originFileObj);
      }
    }
    this.previewImage = file.url || file.preview;
    this.previewVisible = true;
  };

  async handleChange(event) {
    console.log(event);
    if (this.fileList.length && event?.type === 'start') {
      const file = this.fileList[0];
      this.fileUploaded.emit(file);

      if (file.originFileObj) {
        console.log('File:', file);
        const preview = await this.getBase64(file.originFileObj);
        this.previewImage = preview.toString() || file.url;
        console.log('previewImage Image:', this.previewImage);
      }
    }

    if (event?.type === 'removed') {
      this.fileList = [];
      this.previewImage = null;
      this.previewVisible = false;
      this.fileRemoved.emit(new Date().toISOString());
    }
  }

  onKeyDownComponentDefinitionTextArea(event: KeyboardEvent) {
    event?.stopPropagation();
    // if copy or paste is pressed, do not trigger the add component with AI Assistant
    if ((event.ctrlKey || event.metaKey) && (event.key === 'c' || event.key === 'v')) {
      event?.stopPropagation();
      return;
    }
  }

  onClickComponentDefinitionTextArea(event: MouseEvent) {
    event?.stopPropagation();
  }

  onFocusComponentDefinitionTextArea(event: FocusEvent) {
    event?.stopPropagation();
    this.textAreaPlaceholder = '';
  }

  onBlurComponentDefinitionTextArea(event: FocusEvent) {
    event?.stopPropagation();
    this.textAreaPlaceholder = GENERATE_WITH_AI_GUIDANCE;
  }

  onClickGenerateComponent(event: MouseEvent) {
    event?.stopPropagation();
    this.componentGenerationRequest.emit({
      description: this.componentDefinitionDescription || '',
      file: this.fileList.length ? this.fileList[0] : null
    });
  }

  onClickUploadButton(event: MouseEvent) {
  }


  onClickDeleteUploadedImage(event: MouseEvent) {
    event?.stopPropagation();
    this.fileList = [];
    this.previewImage = null;
    this.previewVisible = false;
    this.fileRemoved.emit(new Date().toISOString());
  }

}
